import { Component, OnDestroy, OnInit } from '@angular/core'
import { AggregatedInventoryByMaterialNumber, Fridge } from '../../../types/mpup-types'
import { MpupInventoryService } from '../../../services/mpup-inventory.service'
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs'
import { mergeMap, takeUntil } from 'rxjs/operators'
import { InitialPaginationModel } from '../../../services/mpup-pagination.service'
import { MbTranslatePipe } from '../../../../translations/mbTranslate.pipe'
import { PaginationModel } from '@spartacus/core'
import { MpupAccessPassesService } from '../../../services/mpup-access-passes.service'
import {ViewportScroller} from '@angular/common';

@Component({
  selector: 'mb-mpup-inventory-view',
  templateUrl: './mpup-inventory-view.component.html',
  styleUrls: ['./mpup-inventory-view.component.scss']
})
export class MpupInventoryViewComponent implements OnInit, OnDestroy {

  listItems: ReadonlyArray<AggregatedInventoryByMaterialNumber> = []
  searchTerm$ = new BehaviorSubject('')
  selectedFridge$ = new BehaviorSubject<Fridge | null>(null)
  fridges!: ReadonlyArray<Fridge>

  paginationPage$ = new BehaviorSubject<InitialPaginationModel>({ pageSize: 10, currentPage: 0 })
  paginationStatistics$ = new BehaviorSubject<PaginationModel>({})

  private unsubscribe$ = new Subject<void>()

  constructor (private inventoryService: MpupInventoryService,
               private translatePipe: MbTranslatePipe,
               private accessPassesService: MpupAccessPassesService,
               protected viewportScroller: ViewportScroller) {
  }

  ngOnInit () {
    this.accessPassesService.getFridges()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe( {
        next: (fridges) => {
          this.fridges = fridges.reduce((acc: Array<Fridge>, cur) => {
            const ids = acc.map(f => f.fridgeId)
            if(!ids.includes(cur.fridgeId)) {
              acc.push(cur)
            }
            return acc
          }, [] as Array<Fridge>)
          if(fridges.length > 0) {
            this.selectedFridge$.next(fridges[0])
          }
        }
      })

    combineLatest([this.searchTerm$, this.paginationPage$, this.selectedFridge$])
      .pipe(
        takeUntil(this.unsubscribe$),
        mergeMap(([searchTerm, pagination, fridge]) => (
          this.inventoryService.getInventoryList(searchTerm, pagination, fridge?.fridgeId || '')
        ))
      )
      .subscribe({
        next: (response) => {
          this.paginationStatistics$.next({ ...this.paginationPage$.value, ...response.pagination })
          this.listItems = response.items
        },
        error: (e) => console.error('Error fetching list items:', e)
      })
  }

  ngOnDestroy () {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  updateSelectedFridge (fridge: Fridge): void {
    this.selectedFridge$.next(fridge)
    this.changePage(0)
  }

  getLoading (): Observable<boolean> {
    return this.inventoryService.getLoadingState()
  }

  changePage (page: number) {
    this.paginationPage$.next({ ...this.paginationPage$.value, currentPage: page })
  }

  searchInventoryList (searchTerm: string) {
    this.changePage(0)
    this.searchTerm$.next(searchTerm)
  }

  getPaginationText (): string {
    const p = this.paginationStatistics$.getValue()
    if (p.totalResults !== undefined && p.currentPage !== undefined && p.pageSize !== undefined && p.totalResults !== 0) {
      return `${(p.currentPage * p.pageSize) + 1}-${Math.min((p.currentPage + 1) * p.pageSize, p.totalResults)} ${this.translatePipe.transform('mpupInventory.of')} ${p.totalResults}`
    }
    return ''
  }
}
